module.exports = __webpack_public_path__ + "img/AW.bb648067.svg";